import { arrayFromString } from "util/string";
import cognitoConfig from "./aws/cognito";

const env = (key, defVal) =>
  process.env[`REACT_APP_${key.toUpperCase()}`] || defVal;

const configValues = Object.assign(
  {
    debug: arrayFromString(env("DEBUG", "")) || [],

    authDriver: env("AUTH_DRIVER") || "aws-cognito",

    superadmin: {
      username: env("SUPERADMIN_USERNAME") || "admin",
      password: env("SUPERADMIN_PASSWORD") || ""
    },

    backend: {
      apiUri: env("API_URI"),
      printUri: env("PRINT_URI"),
      printUri2: env("PRINT_URI2"),
      arcUri: env("ARC_URI"),
      lgAdminUri: env("LG_ADMIN_URI"),
      lgApiUri: env("LG_API_URL"),
      proxyUri: env("PROXY_URI"),
      sendToNewsgateUri: env("SEND_TO_NEWSGATE_URI")
    }
  },
  { aws: Object.assign({ cognito: cognitoConfig }) }
);

export default function (configName, defaultValue = null) {
  const configPath = configName.split(".");
  let validConfigPath = true;
  let configValue;

  // It's configValues all the way down
  configPath.forEach((pathFragment) => {
    if (!validConfigPath) {
      return;
    }

    if (!configValue) {
      // Set to root config if not yet set
      configValue = configValues;
    }

    if (configValue[pathFragment] === undefined) {
      validConfigPath = false;
      configValue = undefined;
      return;
    }

    configValue = configValue[pathFragment];
  });

  if (configValue === undefined) {
    return env(configName) || defaultValue;
  }

  return configValue;
}
